<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View {{ utils.getLangTerm('task_analysis_documents.singular', 'Task Analysis Document') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <ng-container *ngIf="task_analysis.task_name">
    <p>{{ task_analysis.task_name }}</p>
  </ng-container>

  <ng-container *ngIf="task_analysis.files?.length">
    <h6 *ngIf="task_analysis.files">Files</h6>
    <app-files-list [view]="true" [files]="task_analysis.files"></app-files-list>
  </ng-container>
</mat-dialog-content>
